import { createFeatureSelector, createSelector } from "@ngrx/store";
import { stepperFeatureKey, StepperState } from './stepper.reducer';

export const getStepperFeature = createFeatureSelector<StepperState>(stepperFeatureKey);

export const getStepperIndex = createSelector(getStepperFeature, (state) => state.stepperIndex);


